<ca-modal-container
    class="file-preview-modal"
    [modalTitle]="fileName || ('MY_WORKSPACE.MY_FILES.FILE_PREVIEWER_HEADLINE' | translate)"
    (dismiss)="dismiss($event)"
>
    <ca-file-previewer data-uit="file-previewer" [data]="data" [type]="type"></ca-file-previewer>
</ca-modal-container>
